import styled from 'styled-components';

const PageSelect = styled.select`
  border: 0;
  background: transparent;
  margin-left: 15px;
  color: ${({ theme }) => theme.COLOR_TABLE_DARK};
  padding: 5px;
  font-size: 16px;
  option {
    color: ${({ theme }) => theme.COLOR_TABLE_DARK};
    font-size: 16px;
  }
  outline: none;
`;

const PaginationContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 15px;
  background-color: white;
  width: 100%;
  box-sizing: border-box;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  background-color: ${({ theme }) => theme.COLOR_BG_DARK};
`;

const PaginationBtnContainer = styled.span`
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  margin-left: 10px;
  margin-right: 10px;
  align-items: center;
  justify-content: center;
  display: flex;
`;

const StyledPagination = {
  PageSelect,
  PaginationContainer,
  PaginationBtnContainer,
};

export default StyledPagination;
